import styled from "styled-components";

export default styled.div`
    padding: 0 15px 25px;
`;
